// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

import React from 'react';

import Svg, { SvgProps } from '../Svg';

interface MessageDotsProps extends SvgProps {
  /** 未読があるかどうか */
  hasUnread?: boolean;
}

const MessageDots: React.FC<MessageDotsProps> = (props) => (
  <Svg {...props} width="26" height="22" viewBox="0 0 26 22">
    <g
      id="グループ_612"
      data-name="グループ 612"
      transform="translate(-39 -128.5)"
    >
      <g
        id="グループ_36"
        data-name="グループ 36"
        transform="translate(40 129.5)"
      >
        <path
          id="長方形_72"
          data-name="長方形 72"
          d="M10,0h4A10,10,0,0,1,24,10V20a0,0,0,0,1,0,0H10A10,10,0,0,1,0,10v0A10,10,0,0,1,10,0Z"
          fill="currentColor"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        {props.hasUnread && (
          <circle
            id="楕円形_15"
            data-name="楕円形 15"
            cx="4"
            cy="4"
            r="4"
            transform="translate(17 -1)"
            fill="#ff184e"
          />
        )}
      </g>
      <path
        id="パス_69"
        data-name="パス 69"
        d="M2.338-6.188a.872.872,0,0,0-.868.868.872.872,0,0,0,.868.868.872.872,0,0,0,.868-.868A.855.855,0,0,0,2.338-6.188ZM7-6.188a.872.872,0,0,0-.868.868A.872.872,0,0,0,7-4.452a.872.872,0,0,0,.868-.868A.855.855,0,0,0,7-6.188Zm4.676,0a.872.872,0,0,0-.868.868.872.872,0,0,0,.868.868.872.872,0,0,0,.868-.868A.855.855,0,0,0,11.676-6.188Z"
        transform="translate(45 145)"
        fill="#fff"
      />
    </g>
  </Svg>
);

MessageDots.displayName = 'MessageDots';

export default MessageDots;
